export default {
  props: {
    gift: {
      type: Object,
      required: false
    }
  }
}
